import React from "react";
import { Button, Form, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function ImageUploadField({ fileList, onChange, hasImage }) {
  return (
    <Form.Item
      label="Imagen"
      validateStatus={hasImage ? "" : "error"}
      help={hasImage ? "" : "Debes seleccionar una imagen"}
    >
      <Upload
        accept=".jpg,.jpeg,.png"
        beforeUpload={() => false}
        fileList={fileList}
        onChange={({ fileList: next }) => onChange(next)}
        maxCount={1}
      >
        <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
      </Upload>
    </Form.Item>
  );
}
